export class Projects {
    title:string= ''
    titleAr:string= ''
    description:string= ''
    descriptionAr:string= ''
    videoLink:string= ''
    facebookLink:string= ''
    image:string= ''
    instagramLink:string= ''
    youtubeLink:string= ''
    tiktokLink:string= ''

}
export class UpdateourProjects {
    id:number=null
    title:string= ''
    description:string= ''
    videoLink:string= ''
    facebookLink:string= ''
    image:string= ''
    instagramLink:string= ''
    youtubeLink:string= ''
    tiktokLink:string= ''




}